module.exports = __webpack_public_path__ + "images/emoji/it.7e175662d4cd4ee33427.png";